<template>

          <!-- 通知公告 -->
          <div class="notice-announcement" v-if="config.loginNoticeShowMode=='1' && config.loginNoticeContent">
            <div class="notice-announcement-title"><div class="laba-wrap" :style="{background:`#${config.schemeColor}`}"><img class="notice-img" src="@/assets/img/laba.svg" alt=""></div>{{i18n['screen.loginnotice.title']||'登录公告'}}</div>
            <div class="notice-announcement-content">
              <el-scrollbar style="height:100%;margin-top: 16px">
                <div class="content">
                  <div v-for="(item,index) in loginNoticeContent" :key="index">{{item}}</div>
                </div>
              </el-scrollbar>
            </div>
          </div>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',
  ],
  data: function data() {
    return {
      loginNoticeContent:[]
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
    this.loginNoticeContent = this.config.loginNoticeContent ? this.config.loginNoticeContent.split('\n'):[]
  },
  methods:{
  }
}
</script>
